import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    articles_container: {
        display: 'flex',
        flexDirection: 'column',
    },
    articles_table: {
        display: 'flex',
        flexDirection: 'column',
    },
    elements_container: {},
    filter_items_container: {
        display: 'flex',
        gap: '8px',
    },
    filter_buttons_container: {
        display: 'flex',
        gap: '8px',
    },
    article_info_container: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: '100px auto 150px 200px 150px 100px 50px',
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
        "&:hover": {
            backgroundColor: `${theme.palette.grey[200]}`,
            cursor: 'pointer',
            border: `1px solid ${theme.palette.secondary.light}`,
            borderLeft: `8px solid ${theme.palette.secondary.light}`,
        }
    },
    article_info_container_small: {
        position: 'relative',
        marginTop: '4px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        placeItems: 'stretch',
        rowGap: 16,
        columnGap: 16,
        backgroundColor: theme.palette.common.white,
        borderRadius: 4,
        padding: 8,
        border: `1px solid ${theme.palette.grey["400"]}`,
        borderLeft: `8px solid ${theme.palette.success.light}`,
    },
    inactive: {
        borderLeft: `8px solid ${theme.palette.error.main}`,
        backgroundColor: `${theme.palette.grey["300"]}8c`,
    },
    image_container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4px',
    },
    menu_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        "& > *": {
            marginLeft: '4px'
        }
    },
    menu_container_small: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        "& > *": {
            marginLeft: '4px'
        }
    },
    filter_container: {
        display: "flex",
        marginTop: '16px',
        justifyContent: 'space-between',
        "& button": {
            justifySelf: "end"
        }
    },
    tools_container: {
        justifyContent: 'space-between',
    },
    search_btn: {
        justifySelf: 'flex-end'
    },
    number: {
        fontSize: '25px',
        marginLeft: '4px'
    },
    title: {
        fontSize: '12px',
        color: theme.palette.grey["600"],
        fontWeight: 800
    },
    value: {
        fontSize: '18px',
        fontWeight: 600,
        marginTop: '3px'
    },
    currency: {
        color: theme.palette.grey[600],
        fontSize: '11px',
        marginLeft: '8px'
    },
    article_name_container: {
        display: 'flex',
        alignItems: 'center'
    },
    confection_price_container: {
        paddingLeft: '5px',
    },
    prices_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
}));

export {useStyles}